import { cerrarSesion } from "../utilities/Seguridad";
import axios from "axios";
import qs from "qs";
import moment from "moment";

const sendAxios = async (config) => {
    let res = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });
    return res;
};

export async function acceso(user, clave) {
    let data = qs.stringify({
        username: user,
        password: clave,
    });
    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/login`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
    };
    

    const response = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            //console.log(error);
            return error;
        });

    return response;
}

export async function getGenerales(token) {
    let config = {
        method: "get",
        url: "",
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    config.url = `${process.env.REACT_APP_URL}/configuracion/comunas`;

    const comunas = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });

    config.url = `${process.env.REACT_APP_URL}/configuracion/paises`;

    const paises = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });

    config.url = `${process.env.REACT_APP_URL}/configuracion/etnias`;

    const etnias = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });

    config.url = `${process.env.REACT_APP_URL}/configuracion/idiomas`;

    const idiomas = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });

    config.url = `${process.env.REACT_APP_URL}/configuracion/parentescos`;

    const parentescos = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            console.log(error);
        });

    let response = { region: [], provincia: [], comuna: [], pais: [], etnia: [], idioma: [], parentesco: [] };
    if (comunas.error === 0) {
        response.region = comunas.region;
        response.provincia = comunas.provincia;
        response.comuna = comunas.comuna;
    }
    if (paises.error === 0) {
        response.pais = paises.pais;
    }
    if (etnias.error === 0) {
        response.etnia = etnias.etnia;
    }
    if (idiomas.error === 0) {
        response.idioma = idiomas.idioma;
    }
    if (parentescos.error === 0) {
        response.parentesco = parentescos.parentesco;
    }

    return response;
}

export async function getListaUsuarios(idColegio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/usuario/listar`,
        headers: {
            "Content-Type": "application/json",
            idcolegio: idColegio,
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            //console.log(error);
            return error;
        });

    return response;
}

export async function crearUsuario(usuario, idColegio, token) {
    let data = qs.stringify({
        username: usuario.email,
        password: usuario.password,
        nombres: usuario.nombres,
        apellido_paterno: usuario.apellido_paterno,
        apellido_materno: usuario.apellido_materno,
        idrol: usuario.rol.id,
        idcargo: usuario.cargo.id,
        estado: usuario.estado ? 1 : 2,
    });

    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/usuario/crear`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            idcolegio: idColegio,
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            //console.log(error);
            return error;
        });

    return response;
}

export async function editarUsuario(usuario, idColegio, token) {
    let data = qs.stringify({
        username: usuario.email,
        password: usuario.password,
        nombres: usuario.nombres,
        apellido_paterno: usuario.apellido_paterno,
        apellido_materno: usuario.apellido_materno,
        idrol: usuario.rol.id,
        idcargo: usuario.cargo.id,
        estado: usuario.estado ? 1 : 2,
    });

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/usuario/editar/${usuario.id}`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            idcolegio: idColegio,
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            //console.log(JSON.stringify(response.data));
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            //console.log(error);
            return error;
        });

    return response;
}

export async function getPerfilUsuario(idColegio, token) {
    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/mi-perfil`,
        headers: {
            idcolegio: idColegio,
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });

    return response;
}

export async function getDataConfiguracion(clave, token) {
    var endpoint = "";
    switch (clave) {
        case "universidades":
            endpoint = "universidades";
            break;
        case "cargos":
            endpoint = "cargos";
            break;
        default:
            endpoint = "universidades";
    }

    let config = {
        method: "get",
        url: `${process.env.REACT_APP_URL}/configuracion/${endpoint}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });

    return response;
}

export async function setUploadFoto(file, token) {
    let data = new FormData();
    //data.append('imagen', fs.createReadStream(pathFoto));
    data.append("imagen", file);
    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/actualizar-imagen`,
        headers: {
            Authorization: `Bearer ${token}`,
            ...data,
        },
        data: data,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });
    return response;
}

export async function updateClaveProfiler(idColegio, token, data) {
    let data1 = qs.stringify({
        contrasenia: data.clave,
        contrasenia_nueva: data.nuevaClave,
    });

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/actualizar-contrasenia`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            idcolegio: idColegio,
            Authorization: `Bearer ${token}`,
        },
        data: data1,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });

    return response;
}

export async function updateUsuarioProfiler(idColegio, token, data) {
    let data1 = qs.stringify({
        idcomuna: data.comuna.idcomuna === undefined ? null : data.comuna.idcomuna,
        titulo: data.titulo,
        fecha_nacimiento: moment(data.fecha_nacimiento).format("YYYY-MM-DD"),
        idcargo: data.cargo.id === undefined ? null : data.cargo.id,
        telefono: data.telefono,
        email: data.email,
        direccion: data.direccion,
        postgrados: data.postgrados,
        // 'firmadigital': data.firmadigital,
        firmadigital: 0,
        iduniversidad: data.universidad.id === undefined ? null : data.universidad.id,
    });

    let config = {
        method: "put",
        url: `${process.env.REACT_APP_URL}/actualizar-perfil`,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            idcolegio: idColegio,
            Authorization: `Bearer ${token}`,
        },
        data: data1,
    };

    const response = await axios(config)
        .then((response) => {
            if (response.data.error === 1) cerrarSesion(response.data);
            return response.data;
        })
        .catch((error) => {
            error["error"] = 1;
            error["mensaje"] = error.message;
            return error;
        });

    return response;
}

export async function deleteUsuario(idUsuario, token) {
    let config = {
        method: "delete",
        url: `${process.env.REACT_APP_URL}/usuario/eliminar/${idUsuario}`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const response = await sendAxios(config);
    return response;
}

export async function deleteUsuarioMasivo(idUsuarioIds, token) {
    let data = new FormData();
    data.append("data", "[" + idUsuarioIds + "]");
    let config = {
        method: "post",
        url: `${process.env.REACT_APP_URL}/usuario/eliminar-masivo`,
        headers: {
            Authorization: `Bearer ${token}`,
        },
        data: data,
    };
    const response = await sendAxios(config);
    return response;
}
